import { computed, unref } from 'vue'

export const useCarousels = async ({
  key,
  params = {},
  defaultValue = [],
  watch = [],
  immediate = true
} = {}) => {
  if (!key) {
    throw new Error('useCarousels requires a unique `key` option for useAsyncData.')
  }

  const { API_ENDPOINTS } = useApiEndpoints()

  const paramsRef = computed(() => unref(params) || {})

  const fetchCarousels = async () => {
    const query = paramsRef.value

    const response = await useBaseOFetchWithAuth(
      API_ENDPOINTS.public.carousels.list,
      Object.keys(query).length ? { query } : {}
    )

    return Array.isArray(response?.data) ? response.data : []
  }

  const watchSources = [paramsRef, ...watch]

  const { data, pending, refresh } = await useAsyncData(
    key,
    fetchCarousels,
    {
      default: () => defaultValue,
      watch: watchSources,
      immediate
    }
  )

  const carousels = computed(() => data.value ?? defaultValue)

  const getCarouselItems = async (carouselId, query = {}) => {
    if (!carouselId) {
      return []
    }

    const response = await useBaseOFetchWithAuth(
      API_ENDPOINTS.public.carousels.items(carouselId),
      Object.keys(query || {}).length ? { query } : {}
    )

    return Array.isArray(response?.data) ? response.data : []
  }

  return {
    carousels,
    pending,
    refresh,
    getCarouselItems
  }
}
